const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const LISTAR_DADOS_ATIVOS = (state, payload) => {
  state.itemsAtivos = payload
}

const LISTAR_DADOS_TIPOS_AGINGS = (state, payload) => {
    state.tipoAgings = payload
}

const LISTAR_DADOS_TIPOS_TAREFAS = (state, payload) => {
    state.tipoTarefas = payload
}

const LISTAR_DADOS_DETALHADOS = (state, payload) => {
  state.dadosDetalhados = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_TAREFA_SELECIONADA = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_TAREFA_OPCAO_TRATATIVA = (state, payload) => {
  state.opcoesTratativas = payload;
}

const ATUALIZAR_TAB_INDEX = (state, payload) => {
  state.tabIndex = payload
}

const INSERIR_TAREFA_MOBILIDADES_E_OPCOES_TRATATIVAS = (state, payload) => {
  state.podeInativar = payload;
}

export {
    LISTAR_DADOS,
    LISTAR_DADOS_ATIVOS,
    LISTAR_DADOS_TIPOS_AGINGS,
    LISTAR_DADOS_TIPOS_TAREFAS,
    CARREGANDO,
    INSERIR_TAREFA_SELECIONADA,
    LISTAR_DADOS_DETALHADOS,
    INSERIR_TAREFA_OPCAO_TRATATIVA,
    ATUALIZAR_TAB_INDEX,
    INSERIR_TAREFA_MOBILIDADES_E_OPCOES_TRATATIVAS
}
